module.exports = __webpack_public_path__ + "img/Img2c_214657_BiEx-23-208.30948ba3.jpg";